import { useRef } from 'react';

import { useModal, ShowFnOutput } from 'mui-modal-provider';

import { Dialog } from '@cast/design-system';

import {
  InstallKentScriptDialogContent,
  InstallKentScriptDialogContentProps,
} from './InstallKentScriptDialogContent';

const InstallKentScriptDialog = ({
  cluster,
  featureBeingInstalled,
  onClose,
  onBack,
  onCancel,
}: InstallKentScriptDialogContentProps) => {
  return (
    <Dialog
      open
      disableCloseOnBackdropClick
      onClose={onClose}
      testId="install-kent-script-dialog"
    >
      <InstallKentScriptDialogContent
        cluster={cluster}
        featureBeingInstalled={featureBeingInstalled}
        onClose={onClose}
        onBack={onBack}
        onCancel={onCancel}
      />
    </Dialog>
  );
};

export const useInstallKentScriptDialog = () => {
  const { showModal } = useModal();
  const showFnOutputRef =
    useRef<ShowFnOutput<InstallKentScriptDialogContentProps>>(undefined);
  const handleClose = () => {
    showFnOutputRef.current?.destroy();
  };

  return {
    showInstallKentScript: (
      props: Omit<InstallKentScriptDialogContentProps, 'onClose' | 'onCancel'>
    ) => {
      showFnOutputRef.current = showModal(InstallKentScriptDialog, {
        ...props,
        onClose: handleClose,
        onCancel: handleClose,
      });
    },
  };
};
